<div class="main-item" [style.width.px]="width" [style.margin]="margin" [style.marginTop.px]="marginTop"  [style.marginLeft.px]="marginLeft" [style.display]="display" [style.float]="float">
    
    <div class="animated-background" [style.height.px]="height">
      <div class="background-masker"></div>
    </div>
  </div>